package com.milta.core.localization.translations.fr

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 adresse non localisée",
    warningTitlePlural = "%d adresses non localisées",
    warningMessage = "Ces livraisons n'ont pas pu être placées sur la carte. Corrigez leur adresse, ou continuez : elles seront mises en fin de tournée.",
    fixAction = "Corriger",
    continueWithoutAction = "Continuer sans elles",
    unplacedStopsSingular = "1 arrêt non placé, en fin de tournée",
    unplacedStopsPlural = "%d arrêts non placés, en fin de tournée",
    fixAddressAction = "Corriger l'adresse",
    unlocatedBadge = "Non localisée",
)
